type AuthAPIUrlsMapKeys = 'logout';

export const authAPIUrls: Record<AuthAPIUrlsMapKeys, `/${string}`> = {
  logout: '/delete-token',
} as const;
